import { render, staticRenderFns } from "./AppTemplateItem.vue?vue&type=template&id=8680ad62&scoped=true"
import script from "./AppTemplateItem.vue?vue&type=script&lang=js"
export * from "./AppTemplateItem.vue?vue&type=script&lang=js"
import style0 from "./AppTemplateItem.vue?vue&type=style&index=0&id=8680ad62&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8680ad62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8680ad62')) {
      api.createRecord('8680ad62', component.options)
    } else {
      api.reload('8680ad62', component.options)
    }
    module.hot.accept("./AppTemplateItem.vue?vue&type=template&id=8680ad62&scoped=true", function () {
      api.rerender('8680ad62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/appTemplateMarket/component/AppTemplateItem.vue"
export default component.exports